import React, { useContext, useState } from "react"
import Textbox from "../input/Textbox"
import { useTranslation } from "react-i18next"
import { FormContext } from "../Form"

const BusinessEmail = ({ required = true, hubspotEmailValidation = false }) => {
  const { t, i18n } = useTranslation("forms")
  const { hubspot: { id, dialogId } } = useContext(FormContext)
  const [hubspotEmailCheckValid, setHubspotEmailCheckValid] = useState(true)

  const requiredError = i18n.exists("forms:inputs.businessEmail.errors.required") ? t("inputs.businessEmail.errors.required") : t("inputsGenerics.requiredError")

  return <Textbox label={t("inputs.businessEmail.label")} name="email" required={required ? requiredError : false} validate={async (value) => {
    if (hubspotEmailValidation && hubspotEmailCheckValid) {
      return fetch(`https://forms.hsforms.com/emailcheck/v1/json-ext?portalId=${dialogId}&formId=${id}`, {
        //return fetch(`https://forms.hsforms.com/emailcheck/v1/json-ext?portalId=9148992&formId=1eda2a49-7427-4e50-b3f9-f9369f3962a3`, {
        method: "POST",
        body: value
      }).then(result => {
        return result.json().then(json => {
          if (json.success) {
            return false // non errore
          } else {
            if (json.message === "form not found") {
              setHubspotEmailCheckValid(false)
              return false
            } else {
              return t("inputs.businessEmail.errors.format")
            }
          }
        })
      })
    } else {
      if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value))) {
        return t("inputs.businessEmail.errors.format")
      }
    }

    return false
  }} />
}

export default BusinessEmail